var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.954 9.744C2.488 9.593.97 10.401.719 11.968c-.607 3.539 4.246 4.044 3.639 1.567-.354-1.466-2.325-1.01-3.033-.151-1.415 1.769-.505 5.964 4.196 4.751",
    stroke: "#0C0A0C",
    strokeWidth: 0.533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.642 27.486c6.364 0 11.524-4.367 11.524-9.755 0-5.388-5.16-9.756-11.524-9.756-6.365 0-11.525 4.368-11.525 9.756 0 5.387 5.16 9.755 11.524 9.755z",
    fill: "#FFBF3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.623 8.834s3.74-4.296 6.571-3.487c1.618.455-1.213 3.79-1.213 6.57l-5.358-3.083zM27.104 14.546h3.437c.404 0 .758.304.758.758.05.759 0 1.82-.354 2.983a9.041 9.041 0 01-.91 1.971.737.737 0 01-.657.354h-3.64l1.366-6.066zM24.425 23.796l-.707 5.56c-.102.658-.607 1.112-1.264 1.112h-2.527c-.658 0-1.214-.505-1.264-1.111l-.404-3.59c-.102-.707.404-1.314 1.111-1.415l5.055-.556zM8.856 23.796l.708 5.56c.101.658.607 1.112 1.264 1.112h2.527c.657 0 1.213-.505 1.264-1.111l.404-3.59c.101-.707-.404-1.314-1.112-1.415l-5.055-.556z",
    fill: "#FFBF3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.869 15.557c.502 0 .91-.498.91-1.112 0-.614-.408-1.112-.91-1.112-.503 0-.91.498-.91 1.112 0 .614.407 1.112.91 1.112z",
    fill: "#0C0A0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.536 26.273c.96.455 2.88 1.213 5.408 1.163a11.355 11.355 0 004.802-1.163M6.936 4.538s2.021 1.415 2.426 2.426M14.012 1.556s.506 1.97.303 3.386M9.766 1.556s1.668 2.325 1.972 3.942",
    stroke: "#0C0A0C",
    strokeWidth: 0.533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgMoney;